module.exports = __webpack_public_path__ + "b459ab4bce6815511a41a6285788b2c9.png";